import React from "react";
import classNames from "classnames";
import {ReactComponent as SmallSpinner} from "./ic-small-spinner.svg";
import styles from "./InlineLoader.module.scss";

export default ({type = "default", className, style}) => {
    return <SmallSpinner className={classNames(styles['base'], styles[type], className)} style={style}/>
};
